import { Text } from '@cdl/heartbeat-react';
import React, { PropsWithChildren } from 'react';

export const Loading: React.FC<PropsWithChildren> = ({ children }) => (
  <Text m='m'>{children || 'Loading...'}</Text>
);
